import React, { useState } from 'react';
import MuiThemeProvider from '@mui/material/styles/ThemeProvider';
import { ThemeProvider } from 'styled-components/';

import { useAppDispatch } from '../redux/hooks';
import * as URLS from '../constants/urls';
import * as api from '../utils/api';
import { getUserInfo } from '../utils/helpers';
import useToggleTheme from '../hooks/useToggleTheme';
import PackageLimitModal from '../components/PackageLimitModal';
import { themeDark, themeLight } from '../theme';
import { updateUserInfo } from './UserInfoSlice';
import { updateAppInfo } from './AppInfoSlice';

const Dashboard = ({ children }) => {
  const dispatch = useAppDispatch();
  const { isDarkMode } = useToggleTheme();
  const [userInfo, setUserInfo] = useState(null);
  const fetchAccountInfo = async () => {
    try {
      const { data } = await api.get(URLS.USER_ME);
      if (data) {
        dispatch(updateUserInfo(getUserInfo(data)));
        setUserInfo(data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const fetchAppInfo = async () => {
    try {
      const { data } = await api.get(URLS.GET_APP_INFO);
      if (data) {
        dispatch(updateAppInfo(data));
      }
    } catch (error) {
      console.error(error);
    }
  };

  React.useEffect(() => {
    fetchAccountInfo();
    fetchAppInfo();
  }, []);

  return (
    <MuiThemeProvider theme={isDarkMode ? themeDark : themeLight}>
      <ThemeProvider theme={isDarkMode ? themeDark : themeLight}>
        <div className="px-3 md:px-6 my-6 mx-auto grid">
          {children}
          {userInfo ? <PackageLimitModal /> : null}
        </div>
      </ThemeProvider>
    </MuiThemeProvider>
  );
};

export default Dashboard;
